const WP_IMAGE_SIZE_SUFFIX = /-\d+x\d+(?=\.(?:jpe?g|png|webp|gif)(?:[?#]|$))/i;

export const getHighResolutionAuthorImage = imageUrl => {
  if (typeof imageUrl !== 'string') {
    return imageUrl;
  }

  return imageUrl.replace(WP_IMAGE_SIZE_SUFFIX, '');
};
